export const URL = {
  ABOUT_HUB: 'https://retail-support.lightspeedhq.com/hc/articles/360045093454',
  SUPPORTED_DEVICES: 'https://retail-support.lightspeedhq.com/hc/articles/360045636354',
  LABEL_PRINTER: 'https://retail-support.lightspeedhq.com/hc/articles/1260806308990',
  CFD: 'https://retail-support.lightspeedhq.com/hc/articles/360042245893',
  LABEL_TROUBLESHOOTING: 'https://retail-support.lightspeedhq.com/hc/articles/115000402107',
  LABEL_EDITOR: 'https://retail-support.lightspeedhq.com/hc/articles/4922303059611',
} as const;
